import { render, staticRenderFns } from "./DocumentUserInformation.vue?vue&type=template&id=51b6cfef"
import script from "./DocumentUserInformation.vue?vue&type=script&lang=ts"
export * from "./DocumentUserInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b6cfef')) {
      api.createRecord('51b6cfef', component.options)
    } else {
      api.reload('51b6cfef', component.options)
    }
    module.hot.accept("./DocumentUserInformation.vue?vue&type=template&id=51b6cfef", function () {
      api.rerender('51b6cfef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentUserInformation.vue"
export default component.exports